import { useSelector } from 'react-redux';
import { AnalysisStep, CliniqueState, StepView } from '../type';
import AnalyseComponent from './analyse';
import NewCamera from '../shadematch/NewCamera';
import OnBoardComponent from './onBoard';
import QuestComponent from './newQuest';
import ResultsComponent from './newResultViews/main';
import TutoComponent from './tuto';
import ReadyComponent from './analysisReady'

const ViewDispatcher = () => {
	const stepView = useSelector((state: CliniqueState) => state.session.stepView);
	const analyseStep = useSelector((state: CliniqueState) => state.session.analyseStep as unknown as AnalysisStep);

	switch (stepView) {
		case StepView.camera:
			return <NewCamera isShadematch={false} />;
		case StepView.pictureAnalyse:
			return <AnalyseComponent isComplete={analyseStep === AnalysisStep.done} startWithoutPredictions />;
		case StepView.onBoard:
			return <OnBoardComponent />;
		case StepView.tuto:
			return <TutoComponent />;
		case StepView.quests:
			return <QuestComponent />;
		case StepView.ready:
			return <ReadyComponent />;
		case StepView.results:
			return <ResultsComponent />;
		default:
			return <NewCamera isShadematch={false} />;
	}
};

export default ViewDispatcher;
